import { useMemo } from 'react';

import { ALGOLIA_SERIES_INDEX_BASE, getLocalizedIndex } from '~/src/common/algolia';
import { useAlgoliaSearchClient } from '~/src/components//hooks';
import { useLocale } from '~/src/components/LocaleProvider';

import { CarouselItem } from './types';

export function useSeriesAlgoliaSearch() {
  const { locale } = useLocale();
  const indexName = getLocalizedIndex(ALGOLIA_SERIES_INDEX_BASE, locale);

  const indexes = useMemo(
    () => [
      {
        indexName,
        facetFilters: null,
      },
    ],
    [indexName],
  );

  const results = useAlgoliaSearchClient<CarouselItem>({
    indexes,
    locale,
  });

  return results;
}
